import { Directive, ElementRef, Input, Renderer2, RendererStyleFlags2 } from '@angular/core';

@Directive({
    selector: '[vhFix], .vh-fix',
    standalone: true
})
export class VhFixDirective {
    @Input() onlyCustomProperties = false;

    constructor(
        protected elementRef: ElementRef,
        protected renderer: Renderer2
    ) {}

    ngOnInit(): void {
        const element = this.elementRef.nativeElement;
        const vhFixValue = 'calc(100vh - calc(var(--vh) * 100))';

        if (!this.onlyCustomProperties) {
            this.renderer.setStyle(element, 'margin-bottom', vhFixValue);
        }

        this.renderer.setStyle(element, '--vh-fix-value', vhFixValue, RendererStyleFlags2.DashCase);
    }
}
